import "./style.scss";
import warningModalIcon from "../../assets/images/warning_modal.svg";
import { Button, DatePicker, message } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

const DOBWarningModal = ({
  isOpen,
  onClose,
  text,
  onOK,
  loader,
  confirmText = "Please confirm your date of birth is",
}) => {
  const [date, setDate] = useState(null);
  const [step, setStep] = useState("form");
  const [placement, setPlacement] = useState("bottomRight");

  useEffect(() => {
    setPlacement(window.screen.width < 1440 ? "center" : "bottomRight");
  }, []);

  console.log("placement : ", placement);
  if (!isOpen) return null;

  const handleSubmit = () => {
    setStep("confirm");
  };

  const handleConfirm = () => {
    onOK(date);
  };

  const handleCancel = () => {
    setStep("form");
  };

  const eighteenYearsAgo = dayjs().subtract(18, "year");

  return (
    <div className="warning-modal-overlay">
      <div className="warning_modal_wrapper">
        <div className="warning_modal_container_top">
          <div className="warning_icon">
            <img src={warningModalIcon} alt="warningModalIcon" />
          </div>
        </div>

        <div
          className="warning-modal-container"
          onClick={(e) => e?.stopPropagation()}
        >
          <div className="warning_modal_container_bottom">
            <h1>Action Required!</h1>

            {step === "form" && (
              <>
                <div className="warning_modal_content">
                  <p>{text}</p>
                  <DatePicker
                    name="date_of_birth"
                    id="date_of_birth"
                    className="customDatePicker"
                    popupClassName="dobPickerDropdown"
                    placeholder="Select date of birth"
                    value={date}
                    onChange={(value) => {
                      if (!value) {
                        setDate(value);
                        return;
                      }

                      if (value.isAfter(eighteenYearsAgo)) {
                        message.error(
                          "You must be at least 18 years old to continue.",
                        );
                        return;
                      }

                      setDate(value);
                    }}
                    disabledDate={(current) =>
                      current && current.isAfter(eighteenYearsAgo)
                    }
                    placement={placement}
                  />
                </div>

                <div className="warning_modal_btn">
                  <Button disabled={!date} onClick={handleSubmit}>
                    Save and Continue
                  </Button>
                </div>
              </>
            )}

            {step === "confirm" && (
              <>
                <div className="warning_modal_content">
                  <p className="confirmText">{confirmText}</p>
                  <strong>{dayjs(date).format("DD MMM YYYY")}</strong>
                </div>

                <div className="warning_modal_btn">
                  <Button onClick={handleCancel}>Back</Button>

                  <Button loading={loader} onClick={handleConfirm}>
                    Yes, Confirm
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DOBWarningModal;
